export function interopRequireDefault(defaultImport) {
  const asAny = defaultImport;
  return asAny.__esModule ? asAny.default : defaultImport;
}